import React, { useState, useEffect } from "react"
import S from "./AddToCart.module.scss"
import { connect } from "react-redux"
import { addToCart } from "../../actions/shoppingCart"
import ProductOptionsModal from "../Skus/ProductOptionsModal"

const AddToCart = ({
  id,
  image,
  name,
  price,
  size,
  sizes,
  cart,
  addToCart,
  quantity,
}) => {
  const [productInCart, productInCartUpdater] = useState(null)
  const [productOptionsModalOpen, productOptionsModalOpenUpdater] = useState(
    false
  )
  const [selectedSize, selectedSizeUpdater] = useState(size)
  const [selectedQuantity, quantityUpdater] = useState()

  useEffect(() => {
    // filters out the cart to find if the product exists in there
    // if the filter returns a an empty array of 0
    // then update the state of the button
    cart.products.filter(product => {
      if (id === product.id) {
        return product
      }
    }).length === 0
      ? productInCartUpdater(false)
      : productInCartUpdater(true)

    // Handles Size One Size
    sizes.length === 1 && sizes[0].size === "ONE SIZE"
      ? selectedSizeUpdater("ONE SIZE")
      : selectedSizeUpdater(size)

    !quantity ? quantityUpdater(1) : quantityUpdater(quantity)
  }, [cart.products, size, sizes, quantity])

  return (
    <>
      <button
        style={{ opacity: productInCart ? "0.5" : "1" }}
        className={S.addtocart}
        disabled={productInCart ? true : false}
        onClick={() => {
          if (selectedSize && selectedQuantity) {
            addToCart({
              id,
              image,
              name,
              price,
              size: selectedSize,
              quantity: selectedQuantity,
            })
          } else {
            productOptionsModalOpenUpdater(true)
          }
        }}
      >
        {!productInCart ? "Add To Cart" : "In Basket"}
      </button>

      {productOptionsModalOpen ? (
        <ProductOptionsModal
          closeModal={() => {
            productOptionsModalOpenUpdater(false)
          }}
          selectedSizeUpdater={size => selectedSizeUpdater(size)}
          quantityUpdater={quantity => quantityUpdater(quantity)}
          onSubmit={() => {
            if (selectedSize && selectedQuantity) {
              addToCart({
                id,
                image,
                name,
                price,
                size: selectedSize,
                quantity: selectedQuantity,
              })
              productOptionsModalOpenUpdater(false)
            } else {
              alert("Please Enter A Size and Quantity")
            }
          }}
          id={id}
          size={selectedSize}
          sizes={sizes}
          quantity={selectedQuantity}
        />
      ) : null}
    </>
  )
}

// map state to props functions
const mapStateToProps = state => {
  return {
    cart: state.shoppingCart,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    addToCart: product => dispatch(addToCart(product)),
  }
}
// calls to connect
export default connect(mapStateToProps, mapDispatchToProps)(AddToCart)
